import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PageHeader = ({ title, description, icon, breadcrumb, children }) => {
  return (
    <div className="page-header-container mb-4 rounded shadow-sm position-relative overflow-hidden">
      <div className="page-header-bg-icon">
        {icon && <FontAwesomeIcon icon={icon} />}
      </div>
      <div className="d-flex align-items-center justify-content-between p-4 position-relative z-1">
        <div className="d-flex align-items-center">
          {icon && (
            <div className="page-header-icon-wrapper me-4 shadow-sm bg-white rounded-circle d-flex align-items-center justify-content-center" style={{ color: "var(--buttonPrimary)" }}>
              <FontAwesomeIcon icon={icon} size="xl" fixedWidth />
            </div>
          )}
          <div className="text-white">
            {breadcrumb && <div className="page-header-breadcrumb text-white-50 small mb-1">{breadcrumb}</div>}
            <h2 className="page-header-title h4 mb-1 fw-bold">{title}</h2>
            {description && <div className="page-header-desc" style={{ color: "rgba(255, 255, 255, 0.85)" }}>{description}</div>}
          </div>
        </div>
        {children && (
          <div className="page-header-actions">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
